export function handleErrors(error, message) {
   

    return {
        data: [],
        statusCode: 478,
        status: false,
        statusText: 'ERROR',
        message: error !== undefined ? mapErrors(error) : message

    }




}
function mapErrors(error) {
    console.log("werwe",error)
    let mes = '';
    if (error.length !== 0) {
        Object.keys(error).forEach(function (key, index) {
            mes = error[key] + '\n'
            console.log(mes)
        });
    }
    return mes
}

